class FeatureChartCompare extends HTMLElement {
  connectedCallback() {
    this._bags = this._parseBags();
    if (!this._bags.length) {
      return;
    }

    this._columns = Array.from(this.querySelectorAll('[data-compare-column]'));
    this._selects = Array.from(this.querySelectorAll('[data-compare-select]'));

    this._selects.forEach((select) => {
      select.addEventListener('change', () => {
        this._applyBag(select.dataset.compareSelect, select.value);
      });

      // Sync column content with the current selection on load.
      this._applyBag(select.dataset.compareSelect, select.value);
    });
  }

  _parseBags() {
    const script = this.querySelector('[data-compare-bags]');

    if (!script) {
      return [];
    }

    try {
      const data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  _findBag(id) {
    const targetId = String(id);
    return this._bags.find((bag) => String(bag.id) === targetId);
  }

  _applyBag(slot, bagId) {
    const bag = this._findBag(bagId);
    const column = this._columns.find((col) => col.dataset.compareColumn === String(slot));

    if (!bag || !column) {
      return;
    }

    const image = column.querySelector('[data-compare-image]');
    const placeholder = column.querySelector('[data-compare-image-placeholder]');
    const price = column.querySelector('[data-compare-price]');
    const values = Array.from(column.querySelectorAll('[data-compare-value]'));

    if (image) {
      if (bag.image) {
        image.hidden = false;
        image.src = bag.image;
        image.alt = bag.image_alt || bag.title || '';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');

        if (placeholder) {
          placeholder.hidden = true;
        }
      } else {
        image.hidden = true;
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';

        if (placeholder) {
          placeholder.hidden = false;
        }
      }
    }

    if (price) {
      price.textContent = bag.price || '';
      price.hidden = !bag.price;
    }

    values.forEach((valueEl) => {
      const valueIndex = Number.parseInt(valueEl.dataset.compareValueIndex, 10);

      if (!Number.isFinite(valueIndex) || valueIndex < 1) {
        return;
      }

      const nextValue = Array.isArray(bag.values) ? bag.values[valueIndex - 1] : '';
      valueEl.innerHTML = nextValue && String(nextValue).trim() !== '' ? nextValue : '—';
    });
  }
}

if (!window.customElements.get('feature-chart-compare')) {
  window.customElements.define('feature-chart-compare', FeatureChartCompare);
}
